module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-07.2dbc275a.png";